<template>
    <div class="full-topics">
        <div ref="graph" class="graph-content"></div>
        <div class="black" @click="goBlack" :class="{'black-class':fullClass}">Exit</div>
        <!--        <div class="fill-topics-type" @click="changeType" v-if="isGraph===1">切换{{$route.params.type==='expert'-->
        <!--            ?'普通探索':'高级探索'}}-->
        <!--        </div>-->
    </div>
</template>

<script>
import {baseUrl} from 'common/js/http/pdBase'
import * as _ from 'lodash'
import MixinGraph from '@/views/TheHome/mixins/handleGraph'
import {getToken} from '@/common/js/http/pdAxios'
import $ from 'jquery'

export default {
  name: 'FullTopics',
  mixins: [MixinGraph],
  data () {
    return {
      apiSearchId: '/ensearch/getEntityId',
      apiSearchNode: '/ensearch/graphExplore2',
      graph: null,
      fullClass: false,
      settings: {
        ajaxSettings: {
          baseUrl: baseUrl + '/country/dz/',
          // baseUrl: config.baseUrl + '/forward/sdk/',
          headers: {
            // APK: '37df4b42bf6442ae8dd263c731dccb6b'
          },
          queryData: {
            p: 'spa_pc_graph'
          },
          beforeLoad: (data) => {
            console.log(data)
            if (data.url.indexOf('/dz/app/graph') !== -1 && data.data.allowTypes && data.data.allowTypes) {
              const classIds = data.data.allowTypes[0]
              const arr = [20, 9]
              if (classIds.length && arr.indexOf(~~classIds) === -1) {
                delete data.data.relevancy
                delete data.formData.relevancy
              }
            }
            // debugger
            return data
          }
        },
        schemaSettings: {
          ajaxSettings: {
            dataFilter: (data) => {
              const _data = JSON.parse(data)
              let arr = []
              const schemaArr = [
                '国家', '城市', '省份', '人物', '关键词', '组织机构',
                '新华丝路情报', '智讯参考', '投资风险周报', '投资风险报告', '公共安全报告']
              _.forEach(schemaArr, (key) => {
                const _item = _.find(_data.data.types, {'v': key})
                _item && arr.push(_item)
              })
              arr.push(..._data.data.types)
              arr = _.uniqBy(arr, 'v')
              _data.data.types = arr
              data = JSON.stringify(_data)
              return data
            }
          }
        },
        showLinkInfoOnClick: true,
        'attValueRule': {
          'enable': false,
          'settings': {
            'box': {
              'isOpen': false
            }
          }
        },
        contextmenu: {
          enable: true,
          settings: {
            menu: {
              'jump': {
                'enable': false,
                'settings': {
                  'children': [
                    {
                      'type': 'graph'
                    },
                    {
                      'type': 'path'
                    },
                    {
                      'type': 'relation'
                    },
                    {
                      'type': 'timing'
                    },
                    {
                      'type': 'explore'
                    }
                  ]
                }
              },
              'business-rule': {
                'enable': false
              },
              'sub-graph': {
                enable: false
              },
              'analysis-path': {
                enable: true
              },
              'analysis-relation': {
                enable: true
              },
              'node-explore': {
                enable: true
              },
              'node-explore-next': {
                enable: true
              },
              'node-explore-previous': {
                enable: true
              },
              jumpSearch: {
                settings: {
                  title: 'Jump to Search', //'跳转至搜索页',
                  click: (a, b, c) => {
                    this.PdJumpSearch()
                  },
                  customEnable: (data) => {
                    window.clickpdNode = data
                    const isNodes = data.nodes && data.nodes.length && data.nodes[0]
                    return isNodes && !(isNodes.classIdList.indexOf(13) !== -1 || isNodes.classIdList.indexOf(5) !== -1)
                  }
                }
              },
              jumpSearchDetail: {
                settings: {
                  title: '跳转至详情页',
                  click: (a, b, c) => {
                    this.PdJumpSearch()
                  },
                  customEnable: (data) => {
                    window.clickpdNode = data
                    const isNodes = data.nodes && data.nodes.length && data.nodes[0]
                    return isNodes && (isNodes.classIdList.indexOf(13) !== -1 || isNodes.classIdList.indexOf(5) !== -1)
                  }
                }
              }
            },
            items: [
              'jumpSearchDetail',
              'jumpSearch',
              'business-rule',
              'layout',
              'node-focus-to',
              'node-explore',
              'analysis-relation',
              'analysis-path',
              'node-explore-previous',
              'node-explore-next',
              'jump',
              'align',
              'node-hide',
              'node-show',
              'sub-graph',
              'node-editor',
              'node-style',
              'link-editor',
              'link-style',
              'other',
              'clear',
              'common-config'
            ]
          }
        },
        infoboxSettings: {
          settings: {
            ajaxSettings: {
              beforeSend: (jqXHR, settings) => {
                if (settings.url.indexOf('infobox') >= 0) {
                  const schemaType = this.graph && this.graph.schema && this.graph.schema.types
                  const id = settings.formData && settings.formData.id
                  for (let item of schemaType) {
                    id.toString() === item.k && (settings.data += '&concept=true')
                  }
                  !settings.formData.concept && (settings.data += '&concept=false')
                }
              },
              formData: {
                // isRelationAtts: true
              }
            }
          }
        },
        // kgName: 'plantdata_bj73pdk7_graph_17332e734da',
        kgName: 'kgms_bj73pb34_graph_17393feda4d',
        netChartSettings: {
          rightPanel: {
            mode: 'fixed',
            active: false
          },
          main: {
            // layout: 'tree',
            // events: {
            //   onClick: (event, arg) => {
            //     this.$emit('changeGraph', event, arg)
            //   },
            //   onDoubleClick: (event, arg) => {
            //     this.$emit('doubleClick', arg.clickItem)
            //   }
            // }
          }
        },
        nodeLegend: {
          enable: true
        },
        linkLegend: {
          settings: {
            color: [
              '#7bc0e1',
              '#9ec683',
              '#fde14d',
              '#ab89f4',
              '#FAC9B8',
              '#dca8c6',
              '#596690',
              '#eaad84',
              '#abe8bf',
              '#7979fc',
              '#FF6F5E',
              '#FFAF5E',
              '#D4B311',
              '#B4D411',
              '#73D411',
              '#11D4B3',
              '#11B3D4',
              '#1152D4',
              '#9311D4'
            ]
          }
        },
        pluginsSettings: {
          settings: {
            size: 'sm'
          }
        },
        promptSettings: {
          ajaxSettings: {
            queryData: {
              isInherit: true,
              openExportDate: true,
              allowTypes: '[37,20,6,34,26,9,16]'
            }
          }
        },
        showAllSchemaOptions: true,
        timeChart: {
          settings: {
            settings: {
              color: [
                '#5677fc'
              ],
              dataZoom: [
                {
                  fillerColor: 'rgba(57, 141, 238, .3)'
                }
              ]
            },
            dialogSettings: {
              defaultTimeFilterSettings: {
                1: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: false,
                  noTimeNodes: true
                },
                2: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: true
                }
              },
              defaultTimeFilterType: '2',
              rule: {
                1: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                2: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                }
              }
            }
          }
        },
        snapshot: {
          enable: false
        },
        selector: '.graph-content',
        loaderSettings: {
          ajaxSettings: {
            formData: {
              isInherit: true,
              hyponymyDistance: 0
            }
          }
        },
        page: {
          enable: true,
          settings: {
            side: 'top'
          }
        },
        toolbar: {
          enable: true,
          settings: {
            menu: {
              fullscreen: {
                enable: false
              },
              export: {
                enable: false
              },
              dragSelect: {
                enable: false
              },
              hoverHighlight: {
                enable: false
              },
              overview: {
                enable: false
              }
            }
            // items: ['back']
          }
        },
        changeLayout: {
          enable: true,
          setting: {
            layout: 'static'
          },
          settings: {
            sankey: false
          }
        },
        find: {
          enable: false
        },
        history: {
          enable: true
        },
        wordCloudView: {
          enable: false
        },
        relativeFiles: {
          enable: false
        },
        visConfigure: {
          enable: false
        },
        filter: {
          enable: true,
          settings: {
            active: true,
            editItemSettings: [
              {
                key: 'isRelationMerge',
                label: 'relationMerge',
                value: 'true',
                options: [
                  {
                    label: 'merge',
                    value: 'true'
                  },
                  {
                    label: 'doNotMerge',
                    value: 'false'
                  }
                ]
              },
              {
                key: 'hyponymyDistance',
                disabled: true
              },
              {
                key: 'distance-expend',
                disabled: false
              },
              {
                key: 'distance',
                disabled: true,
                options: [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6
                ],
                value: 1
              },
              {
                key: 'allowTypes',
                disabled: false,
                index: 1
              },
              {
                key: 'allowAtts',
                index: 1
              },
              {
                key: 'highLevelSize',
                disabled: true
              }, {
                key: 'reliability',
                disabled: true
              }, {
                key: 'isRelationMerge',
                disabled: true
              }, {
                key: 'score',
                disabled: true
              }, {
                key: 'attAttFilters',
                disabled: true
              }, {
                key: 'direction',
                disabled: true
              },
              {
                key: 'distance-expend',
                disabled: true,
                index: 2,
                value: 1
              }
            ]
          }
        },
        prompt: {
          enable: true,
          settings: {
            side: 'left',
            promptSettings: {
              autocompleteSettings: {
                keyword: false
              }
            }
          }
        },
        infobox: {
          enable: false,
          settings: {
            active: false
          }
        },
        resetLayout: {
          enable: true
        },
        wordCloud: {
          enable: false
        },
        advancedPrompt: {
          enable: false
        },
        tagView: {
          enable: false
        },
        zoomSlider: {
          enable: true
        }
      },
      notify: null
    }
  },
  mounted () {
    this.init()
    this.$notify().close()
    // this.notify = this.$notify({
    //   title: '提示',
    //   message: '请输入关键词，对国家、关键词、组织机构、城市、省份、事件、园区进行搜索',
    //   position: 'top-left',
    //   customClass: 'full-topics-notification',
    //   offset: 120,
    //   duration: 8000
    // })
  },
  deactivated () {
    $('.pdvis-page-pagesize-dialog') && $('.pdvis-page-pagesize-dialog').remove()
    $('.pdsdk-filter-edge-dialog') && $('.pdsdk-filter-edge-dialog').remove()
  },
  beforeDestroy () {
    this.notify.close()
    $('.pdvis-page-pagesize-dialog') && $('.pdvis-page-pagesize-dialog').remove()
    $('.pdsdk-filter-edge-dialog') && $('.pdsdk-filter-edge-dialog').remove()
  },
  computed: {
    // ...mapGetters(['isGraph'])
  },
  methods: {
    init () {
      !window.allToken && getToken()
      this.settings.ajaxSettings.headers['api-token'] = window.allToken
      try {
        window.PdLanguage.setLanguage({
          common: {
            _de: '_de',
            add: 'add',
            addSuccess: 'addSuccess',
            all: 'all',
            allOptions: 'allOptions',
            analyse: 'analyse',
            and: 'and',
            apply: 'apply',
            auto: 'auto',
            back: 'back',
            cancel: 'cancel',
            checkAll: 'checkAll',
            clear: 'clear',
            clearAll: 'Clear all',
            confirm: 'confirm',
            confirmDelete: 'confirmDelete',
            confirmDelete$1: 'confirmDelete$1',
            count: 'count',
            custom: 'custom',
            defaultValue: 'defaultValue',
            delete: 'delete',
            deleteConfirm: 'deleteConfirm',
            deleteSuccess: 'deleteSuccess',
            desc: 'desc',
            doNotMerge: 'doNotMerge',
            edit: 'edit',
            enlarge: 'enlarge',
            explore: 'explore',
            export: 'export',
            equal: 'equal',
            event: 'event',
            exist: 'exist',
            expandOrCollapse: 'expandOrCollapse',
            filter: 'filter',
            formControlLabel: {
              checkbox: 'checkbox',
              date: 'date',
              dateRange: 'dateRange',
              datetime: 'datetime',
              datetimeRange: 'datetimeRange',
              input: 'input',
              radio: 'radio',
              select: 'select',
              switch: 'switch',
              group: 'group'
            },
            fullscreen: 'fullscreen',
            fullscreenTitle: 'fullscreenTitle',
            greaterThan: 'greaterThan',
            greaterThanOrEqualTo: 'greaterThanOrEqualTo',
            gt: 'gt',
            gte: 'gte',
            hide: 'hide',
            href: 'href',
            image: 'image',
            imagePlaceholder: 'imagePlaceholder',
            is: 'is',
            inDataLoading: 'inDataLoading',
            inLoading: 'inLoading',
            isEqual: 'isEqual',
            isNot: 'isNot',
            keyword: 'keyword',
            latitude: 'latitude',
            longitude: 'longitude',
            lessThan: 'lessThan',
            lessThanOrEqualTo: 'lessThanOrEqualTo',
            lt: 'lt',
            lte: 'lte',
            max: 'max',
            merge: 'merge',
            min: 'min',
            more: 'more',
            must: 'must',
            name: 'name',
            neq: 'neq',
            nextPage: 'nextPage',
            no: 'no',
            notEqual: 'notEqual',
            notExist: 'notExist',
            object: 'object',
            optional: 'optional',
            options: 'options',
            off: 'off',
            on: 'on',
            or: 'or',
            other: 'other',
            play: 'play',
            prevPage: 'prevPage',
            preview: 'preview',
            range: 'range',
            rename: 'rename',
            required: 'required',
            run: 'run',
            section: 'section',
            selectAll: 'Select All',
            serialNumber: 'serialNumber',
            showOrHide: 'showOrHide',
            show: 'show',
            source: 'source',
            stat: 'stat',
            statistics: 'statistics',
            step: 'step',
            stop: 'stop',
            timeLabel: {
              date: 'date',
              hour: 'hour',
              minute: 'minute',
              month: 'month',
              quarter: 'quarter',
              second: 'second',
              year: 'year'
            },
            title: 'title',
            to: 'to',
            toolbar: 'toolbar',
            type: 'type',
            unknow: 'unknow',
            update: 'update',
            updateSuccess: 'updateSuccess',
            view: 'view',
            yes: 'yes',
            zoomIn: 'zoomIn',
            zoomOut: 'zoomOut'
          },
          other: {
            autocomplete: {
              keyword: 'Please enter key words...',
              noData: 'sorry,noData'
            },
            cluster: '聚簇',
            clusterStats: '聚簇统计',
            collapse: 'collapse',
            collapseTools: '收起工具栏',
            conceptVisualization: '概念可视化',
            expand: 'expand',
            expandTools: '展开工具栏',
            fieldName: '字段名',
            graphView: '图谱展示',
            horizontalView: '横向视图',
            input: '请输入',
            inputType: '输入类型',
            isDisabled: '是否禁用',
            isEditable: '是否可编辑',
            isDeletable: '是否可删除',
            isRequire: '是否必填',
            labelModel: 'Label模式',
            modelVisualization: '模型可视化',
            multiSelect: '多选',
            noAnswer: '没有找到结果',
            number: '数字类型',
            openOrClose: 'Open/Close',
            pagination: {
              first: '首页',
              jumpTo: '跳转到',
              last: '末页',
              page: '页',
              prev: '上一页',
              prev$1Page: '往前翻$1页',
              next: '下一页',
              next$1Page: '往后翻$1页',
              total$1: '共计$1个'
            },
            placeholderModel: 'Placeholder模式',
            reason: '理由',
            relatedNodesCount: '相关实体个数',
            saveValue: '存储值',
            select: 'select',
            setFocus: '设为焦点',
            showModel: '显示模式',
            showName: '显示名称',
            showRelation: '展示对象属性',
            showValue: 'Show value',
            studyOnly: '本页面仅供学习、参考使用<br/>如有侵权，请联系021-35073581',
            text: '文本类型',
            time: '时间',
            topNodes: '模块度最高的Top节点',
            verticalView: '纵向视图'
          },
          graph: {
            attribute: '属性',
            backward: 'backward',
            className: '类别',
            concept: '概念',
            privateAttribute: '私有属性',
            dataAttribute: '数值属性',
            dataType: '数据类型',
            dataTypeMap: {
              integer: '整数',
              float: '浮点数',
              datetime: '日期时间',
              date: '日期',
              time: '时间',
              varchar: '短文本型',
              computed: '计算属性',
              Map: 'Map型',
              text: '文本型',
              // image: '图片',
              // file: '文件',
              // media: '音、视频',
              href: '超链接'
            },
            dataUnit: '单位',
            define: '定义',
            domain: '定义域',
            direction: '指向',
            edgeDataAttribute: '边数值属性',
            edgeObjectAttribute: '边对象属性',
            endTime: '结束时间',
            entity: '实体',
            event: '事件',
            forward: 'forward',
            from: '起点',
            hypermymyAndHyponymy: '上下位',
            infobox: '知识卡片',
            instance: '实例',
            meaningTag: '消歧标识',
            name: '名称',
            notSingeType: '非单值型',
            objectAttribute: '对象属性',
            private: '私有',
            privateRelation: '私有关系',
            range: '值域',
            relation: '关系',
            singleType: '单值型',
            startTime: '开始时间',
            to: '终点',
            type: '类型',
            twoWay: 'twoWay',
            undirected: '无向',
            vague: '虚化',
            display: {
              circle: 'Circle',
              diamond: 'Diamond',
              roundText: 'Round text',
              roundRect: 'Round text',
              rectangle: 'Rectangle',
              custom: '自定义'
            }
          },
          plugin: {
            contextmenu: {
              entityEdit: '实体编辑',
              entityStyle: 'Node style',
              other: 'Other operations',
              relationEdit: '关系编辑',
              relationStyle: 'Link style'
            },
            resetLayout: {
              resetLayout: 'Reset layout'
            },
            attValueRule: {
              all: 'all',
              attributeFilter: 'attributeFilter',
              configIsNeed: 'configIsNeed',
              entityNoDataTip: 'entityNoDataTip',
              entityNoAttributeValue: 'entityNoAttributeValue',
              equalConditionCannotEmpty: 'equalConditionCannotEmpty',
              existConditionCannotEmpty: 'existConditionCannotEmpty',
              loadAttributeFailed: 'loadAttributeFailed',
              maxMustGreaterThenMin: 'maxMustGreaterThenMin',
              minMaxCannotEmpty: 'minMaxCannotEmpty',
              noCondition: 'noCondition',
              notEqualConditionCannotEmpty: 'notEqualConditionCannotEmpty',
              notExistConditionCannotEmpty: 'notExistConditionCannotEmpty',
              notSpecified: 'notSpecified',
              relationFilter: 'relationFilter',
              relationNoAttributeValue: 'relationNoAttributeValue',
              relationNoDataTip: 'relationNoDataTip',
              secondFilter: 'secondFilter',
              selectedRangeIsEmpty: 'selectedRangeIsEmpty',
              unknowType: 'unknownType'
            },
            changeLayout: {
              changeLayout: 'Change layout',
              force: 'Dynamic layout',
              horizontalLine: 'Horizontal layout',
              layout: 'Layout',
              leftTree: 'Left tree layout',
              line: 'Linear layout',
              pack: 'Package layout',
              partition: 'Partition layout',
              radial: 'Radial layout',
              radialForce: 'Radial force layout',
              ring: 'Circular layout',
              reverseTree: 'Reverse tree layout',
              rightTree: 'Right tree layout',
              sankey: 'Sangji layout',
              static: 'Static layout',
              tree: 'Tree layout',
              treemap: 'Rectangle tree layout',
              verticalLine: 'Vertical layout'
            },
            page: {
              customPageSize: 'customPageSize',
              dataLoadingTryLater: 'dataLoadingTryLater',
              noMoreData: 'noMoreData',
              next: 'next',
              page: 'page',
              prev: 'prev',
              eachPage: 'eachPage',
              thisIsTheFirstPage: 'thisIsTheFirstPage'
            },
            prompt: {
              advancedPrompt: 'advancedPrompt',
              prompt: 'prompt',
              promptMulti: 'promptMulti',
              add: 'add',
              added: 'added',
              addRule: 'addRule',
              in: 'in',
              inputSearchKeyword: 'inputSearchKeyword~',
              keyword: 'keyword',
              registeredCapital: 'registeredCapital',
              resultIsNotFound: 'resultIsNotFound~',
              rule: 'rule',
              searchKeyword: 'searchKeyword',
              searchResult: 'searchResult',
              searchRule: 'searchRule',
              selectedAnalysisEntities: 'selectedAnalysisEntities'
            },
            history: {
              history: 'history'
            },
            visConfigure: {
              arrow: 'Arrow',
              border: 'Border',
              color: 'Color',
              crop: 'Crop',
              display: 'Shape',
              displayValue: '边类型',
              icon: '图',
              image: 'Image',
              inner: 'Inline tags',
              inputNodeLabel: '文字内嵌',
              label: 'Tags',
              labelColor: 'Tag color',
              length: 'Length',
              link: 'Link',
              linkLength: '排斥间距（仅动态布局有效）',
              linkStyle: '边样式',
              linkVisualConfigure: 'Link style configuration',
              node: 'Node',
              nodeLabel: 'Node label',
              nodeSpacing: '节点距离',
              nodeStyle: '节点样式',
              nodeVisualConfigure: 'Node style configuration',
              outputNodeLabel: '文字置底',
              radius: 'Radius',
              rowSpacing: '层距(仅树形布局有效)',
              text: '文',
              vague: '虚化',
              visualConfigure: '配置',
              width: 'Width'
            },
            filter: {
              addRule: 'addRule',
              allowAttrGroups: 'allowAttrGroups',
              allowAtts: 'Set analysis relationship',
              allowTypes: 'Set analysis subject',
              attAttFilters: 'attAttFilters',
              close: 'close',
              custom: {
                distance: 'distance'
              },
              direction: 'direction',
              distance: 'distance',
              distanceExpend: 'distanceExpend',
              doNotMerge: 'doNotMerge',
              explore: {
                distance: 'distance'
              },
              filter: 'filter',
              filterableAttributeOrRelationIsNotExist: 'filterableAttributeOrRelationIsNotExist',
              graph: {
                distance: 'distance'
              },
              highLevelSize: 'highLevelSize',
              hyponymyDistance: 'hyponymyDistance',
              level: 'level',
              merge: 'merge',
              path: {
                distance: 'distance'
              },
              relation: {
                distance: 'distance'
              },
              relationMerge: 'relationMerge',
              reliability: 'reliability',
              score: 'score',
              showAll: 'Show All'
            }
          },
          menuItem: {
            // analysisPath: '路径发现',
            // analysisRelation: '关联关系',
            // addOtherGraph: '添加子图',
            // align: '对齐',
            // alignBottom: '底部对齐',
            // alignLeft: '左侧对齐',
            // alignRight: '右侧对齐',
            // alignTop: '顶部对齐',
            applyStyle: 'Apply',
            // backgroundSize: '背景尺寸',
            // backgroundSizeAuto: '平铺',
            // backgroundSizeCover: '填充',
            // backgroundSizeContain: '适应',
            // backgroundUrl: '背景图片地址',
            // businessRule: '业务规则',
            // closeNode: '关闭节点',
            // collapseNode: '折叠节点',
            commonConfig: 'General Settings',
            // dragSelect: '拖选（按住s键）',
            // editor: '可视化编辑',
            embedNodeLabel: 'Inline tags',
            emphasisLink: 'Highlight link',
            emphasisNode: 'Highlight node',
            // explore: '图谱分析Pro',
            exploreNode: 'Expend node',
            // exploreNodeNext: '探索下一页',
            // exploreNodePrevious: '探索上一页',
            // expandNode: '展开节点',
            focusNode: 'Change center node',
            // graph: '图探索',
            hideLink: 'Hide links',
            hideLinkLabel: 'Hide tags',
            hideNode: 'Hide nodes',
            // hideNodeImage: '隐藏图片',
            hideNodeLabel: 'Hide tags',
            // hideUnlinkedNode: '隐藏无关联的节点',
            // hoverHighlight: '突出hover元素',
            // horizontalCenter: '水平对齐',
            // horizontalDistribution: '水平分布',
            // jumpTo: '图谱跳转',
            // linkConfig: '边配置',
            // linkEmphasisColor: '高亮色',
            // linkEmphasisRadiusRatio: '高亮宽度比率',
            // linkReduceColor: '虚化色',
            // linkReduceRadiusRatio: '虚化宽度比率',
            linkStyleConfig: 'Style configuration',
            lockNode: 'Lock node',
            // nodeConfig: '节点配置',
            // nodeEmphasisColor: '高亮色',
            // nodeEmphasisRadiusRatio: '高亮半径比率',
            // nodeReduceColor: '虚化色',
            // nodeReduceRadiusRatio: '虚化半径比率',
            nodeStyleConfig: 'Style configuration',
            outputNodeLabel: 'Outline tags',
            // path: '路径发现',
            // pathTiming: '时序路径发现',
            reduceLink: 'Blur Links',
            reduceNode: 'Blur nodes',
            // relation: '关联关系',
            // relationTiming: '时序关联关系',
            revertStyle: 'Cancel',
            // showAllRelatedLinks: '显示关联边',
            // showLink: '显示边',
            showLinkLabel: 'Show tags',
            // showNode: '显示节点',
            // showNodeImage: '显示图片',
            showNodeLabel: 'Show tags',
            // timing: '时序图探索',
            unemphasisLink: 'Cancel highlight',
            unemphasisNode: 'Cancel highlight',
            unlockNode: 'Cancel lock',
            unreduceLink: 'Cancel blur',
            unreduceNode: 'Cancel blur',
            // verticalCenter: '垂直对齐',
            // verticalDistribution: '垂直分布',
            // visualEdit: '可视化编辑',
          }
        })
        this.graph = new PdSDKDcGraph(this.settings)
        this.graph.on('inited', () => {
          const query = this.$route.query
          const node = JSON.parse(localStorage.getItem('graphNode'))
          if (query && query.params) {
            if (node && node.id.toString() === query.params) {
              if (this.$route.params.type === 'expert') {
                const {name, id, classId, type} = node
                const o = {
                  id: id.toString(),
                  classId: classId.toString(),
                  name,
                  type
                }
                this.graph.expandEntity([o], {$source: 'api'})
              } else {
                // this.graph.load({id: node.id})
                this.searchNode(node.id)
                  .then((data) => {
                    let focus = null
                    if (data.entityList && data.entityList.length) {
                      focus = data.entityList[0]
                    }
                    this.graph.netChart.addData(data, focus)
                  })
              }
            }
          } else {
            this.graph.load()
          }
          this.graph.netChart.sidePanels.right.on('visibleChange', (data) => {
            this.fullClass = !this.fullClass
          })
        })
      } catch (e) {
        setTimeout(() => {
          this.init()
        }, 500)
      }
    },
    goBlack () {
      this.$router.go(-1)
    },
    // changeType () {
    //   const type = this.$route.params.type
    //   const path = this.$route.fullPath.replace(type, type === 'expert' ? 'common' : 'expert')
    //   this.$router.replace({path})
    //   this.init()
    // },
    PdJumpSearch () {
      const node = window.clickpdNode
      this.jumpSearch(node)
    }
  }
}
</script>

<style scoped lang="less">
    /deep/ .active {
        border: none;
    }

    .active {
        border: none;
    }

    .graph-content {
        width: 100%;
        height: 100%;
        position: relative;
    }

    /deep/ svg {
        vertical-align: unset;
    }

    .black {
        position: absolute;
        bottom: 42px;
        right: 63px;
        color: #0a75be;
        cursor: pointer;
        font-size: 16px;
        z-index: 99;
        padding: 2px;
        background: #fff;
        border-radius: 2px;
        transform: translateX(2px);
        transition: all .5s cubic-bezier(.25, .8, .25, 1) 0s;
    }

    .black-class {
        transform: translateX(-390px);
    }
</style>

<style lang="less" scoped>

    .full-topics {
        height: calc(100vh - 65px);
    }

    .fill-topics-type {
        position: absolute;
        top: 15px;
        left: 290px;
        padding: 8px;
        line-height: 26px;
        background: #fff;
        font-size: 14px;
        color: rgba(0, 0, 0, .6);
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1);
        cursor: pointer;
        z-index: 1000;
    }

    /deep/ .plantdata-ns .pdvis-reset-layout-container .pdvis-float-item-head {
        width: 131px;
    }
</style>

<style>
    .full-topics-notification {
        left: 178px !important;
    }

    .pdui-modal .active {
        border: none;
    }
</style>
